import React from "react";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const CustomerStorageItemListSkeleton: React.FC = () => {
  return (
    <>
      <div className="hidden grid-cols-[2fr_repeat(3,1fr)0.25fr] gap-2 bg-base-light-grey px-6 py-3 text-grey-dark md:grid">
        <Skeleton className="text-xs"></Skeleton>
        <Skeleton className="text-xs"></Skeleton>
        <Skeleton className="text-xs"></Skeleton>
        <Skeleton className="text-xs"></Skeleton>
        <Skeleton className="flex justify-end gap-6 text-xs"></Skeleton>
      </div>
      {Array(4)
        .fill(0)
        .map((_, index) => (
          <React.Fragment key={`p-${index}`}>
            <div
              key={`p-1-${index}`}
              className="flex justify-between gap-2 px-4 py-3 md:hidden"
            >
              <div className="w-3/4">
                <Skeleton className="mb-2 w-full text-sm" />
                <Skeleton className="w-1/2 text-sm" />
              </div>
              <Skeleton className="h-1/2 w-1/4 text-sm" />
            </div>
            <div className="hidden w-full grid-cols-[2fr_repeat(3,1fr)0.25fr] items-center gap-2 whitespace-nowrap px-6 py-4 md:grid">
              <Skeleton className="text-md w-full" />
              <Skeleton className="text-md w-full" />
              <Skeleton className="text-md w-full" />
              <Skeleton className="text-md w-full" />
              <Skeleton className="text-md w-full" />
            </div>
          </React.Fragment>
        ))}
    </>
  );
};
